
const StatistiquesCommercial = function(element, options) {
    this.element = $(element);
    this.form = this.element.find('form');
    this.results = this.element.find('[data-stats-table]');

    this.form.ajaxForm({
        dataType: 'json',
        success: response => {
            if (response.success) {
                this.results.html(response.tableau);

                $('html, body').animate({
                    scrollTop: this.results.offset().top
                }, 500);

                this.fixErrors();
            } else {
                this.element.parent().html(response.form);
            }
        },
        complete: () => {
            this.form.formLoading()
        }
    });

    this.results.on('query.table', 'table', (event, params) => {
        $.extend(params, this.getFormData());
    })
};

$.extend(StatistiquesCommercial.prototype, {
    fixErrors: function() {
        this.form.find('.has-error').removeClass('has-error');
        this.form.find('.help-block').remove();
    },

    getFormData: function() {
        let data = {};
        const serialized = this.form.serializeArray();

        $.each(serialized, function() {
            const name = this.name, value = this.value;
            if (data[name] !== undefined) {
                if (!data[name].push) {
                    data[name] = [ data[name] ];
                }
                data[name].push(value || '');
            } else {
                data[name] = value || '';
            }
        });

        return data;
    }
});

$.fn.statistiquesCommercial = function(options) {
    return $.each(this, function () {
        new StatistiquesCommercial(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/statsCommercial.js